<template>
  <div>
    <div class="page-header clear-filter" filter-color="orange">
      <parallax
        class="page-header-image"
        style="background-image:url('img/header.jpg')"
      >
      
      </parallax>
      <div class="container">
        <div class="content-center brand">
          <img  src="img/Logo_Gateway.png" alt="" />
          <div class="container text-center">
            <div class="row justify-content-md-center">
              <div class="col-md-12 col-lg-8">
                <h2 class="title">Soluciones Tecnológicas Eficientes</h2>
                <p class="description">
                  Bannner Grande de la empresa
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="section">
      <div class="container text-center">
        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <h2 class="title">Del lado de la tecnologia e innovación</h2>
            <h5 class="description">
              Aqui puedes ver el listado completo de nuestros productos, escribenos a whatsapp para conocer mas
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="section">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <GridProducts/>
              <router-link to="/productos">
              <n-button type="primary" size="lg" wide>Conoce mas productos</n-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <basic-elements></basic-elements>
    <navigation></navigation>
    <progress-pagination></progress-pagination>
    <notifications></notifications>
    <typography></typography>
    <javascript-components></javascript-components>
     -->
    
  </div>
</template>
<script>
import {Button} from '../components'
// import BasicElements from './components/BasicElementsSection';
// import Navigation from './components/Navigation';
import GridProducts from './components/GridProducts.vue';
// import ProgressPagination from './components/ProgressPagination';
// import Notifications from './components/Notifications';
// import Typography from './components/Typography';
// import JavascriptComponents from './components/JavascriptComponents';
// import CarouselSection from './components/CarouselSection';


export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    // BasicElements,
    // Navigation,
    [Button.name]: Button,
    GridProducts,
    // ProgressPagination,
    // Notifications,
    // Typography,
    // JavascriptComponents,
    // CarouselSection,
  }
};
</script>
<style></style>
